import AddTwoToneIcon from '@mui/icons-material/AddTwoTone'
import { Box, Button, Divider, List, ListItem, Typography } from '@mui/material'
import { Checkboxes, TextField } from 'mui-rff'
import { Form, FormSpy } from 'react-final-form'
import { WbTableRowDeleteButton } from 'src/components/WbTable'
import { MasterWorkoutExerciseSet } from 'src/types/MasterWorkoutExercise'

interface MasterWorkoutExerciseSetsListProps {
	initialValues: MasterWorkoutExerciseSet[]
	onEdit: (idx: number, value: any) => void
	onRemove: (idx: number) => void
	onAdd: () => void
	canEdit: boolean
}

const MasterWorkoutExerciseSetsList: React.FC<MasterWorkoutExerciseSetsListProps> = ({ initialValues, onEdit, onRemove, canEdit, onAdd }) => {
	return (
		<List sx={{ width: '100%', padding: 0, margin: 0 }}>
			{initialValues.map((set, idx) => (
				<ListItem key={set.displayOrder}>
					<Typography minWidth={65}>Set: {set.displayOrder + 1}</Typography>

					<Form
						onSubmit={onEdit}
						initialValues={set}
						render={() => (
							<form style={{ width: '100%' }}>
								<fieldset disabled={!canEdit} style={{ border: 'none' }}>
									<Box display="flex" alignItems="center">
										<FormSpy onChange={({ values, dirty }) => dirty && onEdit(idx, values)} subscription={{ values: true, dirty: true }} />
										<TextField multiline type="text" label="note" name="note" />

										<Divider flexItem orientation="vertical" sx={{ mx: 2 }} />

										<Box display="flex" flexDirection="column" minWidth={115}>
											<Checkboxes
												name="isChild"
												data={{
													label: 'Is Child',
													value: set.isChild,
												}}
											/>
											<Checkboxes
												name="isToFailure"
												data={{
													label: 'To Failure',
													value: set.isToFailure,
												}}
											/>
										</Box>
									</Box>
								</fieldset>
							</form>
						)}
					/>
					{canEdit && <WbTableRowDeleteButton onClick={() => onRemove(idx)} />}
				</ListItem>
			))}
			{canEdit && (
				<ListItem>
					<Box width="100%" display="flex" justifyContent="center" alignItems="center">
						<Button variant="outlined" startIcon={<AddTwoToneIcon fontSize="small" />} onClick={onAdd}>
							Add Set
						</Button>
					</Box>
				</ListItem>
			)}
		</List>
	)
}

export default MasterWorkoutExerciseSetsList
